import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbGithub: BowlBlock = withIntegration(options.slug.llmKbGithub, [
  {
    name: 'accessToken',
    type: 'withText',
  },
  {
    name: 'repo',
    type: 'withText',
    required: true,
  },
  {
    name: 'branch',
    type: 'withText',
    defaultValue: 'main',
  },
  {
    name: 'fileExt',
    type: 'text',
    hasMany: true,
  },
]);
